import { Reveal, SectionTag, SectionTitle } from "@/components/bits";
import { Quote } from "lucide-react";

export const Hl = ({ children }) => (
  <em className="box-decoration-clone bg-crimson px-1 py-0.5 not-italic text-cream">{children}</em>
);

export const FeaturedQuote = ({ children, name, place, testid }) => (
  <figure
    data-testid={testid}
    className="relative mx-auto max-w-3xl border border-gold/25 bg-soot/70 p-10 text-center sm:p-14"
  >
    <Quote size={26} className="mx-auto text-crimson-light" />
    <blockquote className="mt-8 font-serif text-xl italic leading-relaxed text-bone sm:text-2xl">
      {children}
    </blockquote>
    <figcaption className="mt-8 border-t border-gold/10 pt-6">
      <p className="font-sans text-xs font-medium uppercase tracking-[0.22em] text-cream">{name}</p>
      <p className="mt-1 font-sans text-[10px] uppercase tracking-[0.22em] text-ash">{place}</p>
    </figcaption>
  </figure>
);

const CLUB_QUOTES = [
  {
    slug: "myriam",
    text: (
      <>
        Estaba muy ansiosa, porque presentía que iba a ser una experiencia interesante: justamente buscaba poder{" "}
        <Hl>aprender junto con otrxs y ampliar la mirada</Hl>. Me gustó la espontaneidad de Aldana, que nos abre la
        posibilidad de <Hl>«pensar en voz alta»</Hl>. No tengo ninguna propuesta para mejorar el Club:{" "}
        <Hl>así como es, cumplió mis expectativas y me quedo con una sensación plena</Hl>.
      </>
    ),
    name: "Myriam",
    place: "Lectora del Club · marzo a julio",
  },
  {
    slug: "catalina",
    text: (
      <>
        Mi relación con la lectura siempre fue de mucho placer, pero con dificultad para hacerle espacio. El taller
        me dio la posibilidad de encontrar ese espacio y de que no quede ahí solamente: hacer{" "}
        <Hl>una segunda lectura, pero conjunta</Hl>. Me voy con mucha{" "}
        <Hl>gratitud al espacio, a la guía y a las compañeras</Hl>. Fue un lugar donde por un rato solo pensaba de
        forma poética y reflexiva: <Hl>un placer hasta necesario en los tiempos que corren</Hl>.
      </>
    ),
    name: "Catalina",
    place: "Lectora del Club · febrero a mayo",
  },
];

export default function Testimonios() {
  return (
    <section id="testimonios" data-testid="testimonios-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionTag>Lectoras que pasaron por El Club de lectura</SectionTag>
          <SectionTitle className="mt-6">
            Lo que <span className="font-semibold not-italic text-gold">cambia</span> después.
          </SectionTitle>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {CLUB_QUOTES.map((q, i) => (
            <Reveal key={q.slug} delay={i * 0.1}>
              <figure
                data-testid={`testimonio-${q.slug}`}
                className="flex h-full flex-col border border-gold/15 bg-soot/70 p-8 transition-colors duration-500 hover:border-gold/35 sm:p-10"
              >
                <Quote size={22} className="text-crimson-light" />
                <blockquote className="mt-6 flex-1 font-serif text-base italic leading-relaxed text-bone sm:text-lg">
                  {q.text}
                </blockquote>
                <figcaption className="mt-8 border-t border-gold/10 pt-5">
                  <p className="font-sans text-xs uppercase tracking-[0.22em] text-cream">{q.name}</p>
                  <p className="mt-1 font-sans text-[10px] uppercase tracking-[0.22em] text-ash">{q.place}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
